export default __webpack_public_path__ + "6ab29b14a0ff21687c6bbc67087a3c5a.jpg";